module.exports = __webpack_public_path__ + "static/media/chair.83ae9e37.svg";